import React from 'react'
import { observer } from 'mobx-react-lite'
import { noteTakerStore } from 'shared/stores/noteTakerStore'
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg'
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg'
import { ReactComponent as NoteIcon } from 'assets/icons/dock_pen.svg'
import SessionAudioPlayer from './SessionAudioPlayer'
import s from '../NoteTakerDrawer.module.scss'

const formatDate = value =>
	new Date(value).toLocaleDateString('en-US', {
		month: 'long',
		day: 'numeric',
		year: 'numeric',
	})

const SessionNoteCard = observer(({ title, createdAt, durationMs, sessionNoteId, audioEnabled }) => {
	const transcriptMinutes = Math.max(1, Math.round((durationMs || 0) / 60000))
	const isTranscriptOpen = noteTakerStore.isTranscriptDrawerOpen

	return (
		<section className={s.noteCard}>
			<div className={s.noteCardLabel}>
				<NoteIcon />
				<span>Note</span>
			</div>

			<div className={s.noteCardHead}>
				<h1>{title}</h1>
				<div className={s.noteMetaRow}>
					<div className={s.noteMeta}>
						<span className={s.noteMetaItem}>
							<CalendarIcon />
							{formatDate(createdAt)}
						</span>
						<span className={s.metaDot} />
						<span className={s.noteMetaItem}>
							<ClockIcon />
							{transcriptMinutes} min transcript
						</span>
					</div>

					<button
						type="button"
						className={[
							s.transcriptToggleButton,
							isTranscriptOpen ? s.transcriptToggleButtonActive : '',
						]
							.filter(Boolean)
							.join(' ')}
						onClick={() => noteTakerStore.toggleTranscriptDrawer()}
					>
						{isTranscriptOpen ? 'Hide transcript' : 'Show transcript'}
					</button>
				</div>

				<SessionAudioPlayer
					sessionNoteId={sessionNoteId}
					durationMs={durationMs}
					enabled={audioEnabled}
				/>
			</div>
		</section>
	)
})

export default SessionNoteCard
